import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/about/block2-功能介绍.png")